module.exports = "/_next/static/files/a3a6d7e9e386c9bcf6ec37771a8d380a.png";